import React from 'react';

type InputProps = {
  title: string;
  onClose: () => void;
  notificationBody: JSX.Element;
  subtitle?: string;
  actions?: React.ReactNode | null;
};

export const UiNotification = ({
  title,
  subtitle,
  notificationBody,
  onClose,
  actions,
}: InputProps) => (
  <div className="u-width-350px card--floating">
    <div className="u-padding u-background-primary u-color-white u-display-flex u-justifyContent-spaceBetween">
      <div>{title}</div>
      <div role="presentation" onClick={onClose} className="typo-link-secondary">
        X
      </div>
    </div>
    <div className="u-padding">
      {subtitle && <div className="typo-subtitle">{subtitle}</div>}
      <div className="u-maxHeight-600px u-overflowY-scroll">{notificationBody}</div>
      {actions}
    </div>
  </div>
);
